
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

interface UnitCardProps {
  unit: string;
  indentLevel: number;
}

export function UnitCard({ unit, indentLevel }: UnitCardProps) {
  return (
    <Link
      to={`/history/${unit.toLowerCase()}?fromUnit=${unit.toLowerCase()}`}
      className="block transform hover:translate-x-2 transition-all duration-300"
      style={{
        marginLeft: `${indentLevel * 1}rem`,
      }}
      aria-label={`Learn about the history of ${unit} measurements`}
    >
      <Card className="bg-gradient-to-br from-manuscript-background/90 to-manuscript-secondary/30
                     border border-manuscript-primary/10 hover:shadow-lg
                     transform transition-all duration-300 hover:scale-105
                     relative overflow-hidden group">
        <div className="absolute inset-0 bg-manuscript-primary/5 opacity-0 
                      group-hover:opacity-100 transition-opacity duration-300"/>
        <CardContent className="p-4">
          <p className="text-lg font-medium text-manuscript-primary text-left relative z-10">
            {unit}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
}
